<template>
    <div>
        <div class="flex">
            <div class="mx-2 flex">
                <h4>Automation Name</h4>
            </div>
            <div class="flex">
                <input type="text" class="form-control" v-model="form.name" placeholder="Enter Automation Name">
                <span class="required-field ml-2" style="line-height: normal;">*</span>
            </div>
        </div>
        <hr/>
        <div v-show="firstStep">
            <div class="custom-height pb-3">
                <div>
                <div class="flex flex-column automation-trigger p-1 pb-3 mt-2">
                    <div class="mb-2">
                        <div>Trigger</div>
                    </div>
                    <div class="trigger br-10">
                        When a
                        <button class="btn btn-primary mr-2 capitalize" v-if="form.automation_object">{{ form.automation_object }}</button>
                        <button v-if="['activity_added', 'activity_completed', 'activity_due'].includes(form.automation_trigger) && form.automation_field !== 'empty'" class="btn btn-light-green mr-2 text-capitalize">{{ form.automation_field.replace('_', ' ') }} Activity</button>
                        <span v-if="form.automation_trigger">
                            is
                        <button class="btn btn-light-green mr-4 capitalize">{{form.automation_trigger.replace('activity', '').replace('_', ' ')}}</button>
                            then...
                        </span>
                    </div>
                </div>
            </div>
                <div class="mt-3 mb-3">
                    <p class="mb-1">1. Select an automation type <span class="required-field">*</span></p>
                    <div>
                        <button class="btn btn-blue text-white mr-2" :class="getSelectedClass('event_based')"
                                @click="changeSelected('automation_type', 'event_based')">Event based</button>
                        <button class="btn btn-blue text-white" :class="getSelectedClass('time_based')"
                                @click="changeSelected('automation_type', 'time_based')">Time based</button>
                    </div>
                </div>
                <div class="mt-4 mb-4 time-based-properties-section card" v-if="form.automation_type === 'time_based'">
                    <div class="row d-flex align-items-end">
                        <div class="col-4">
                            <span class="text-sm">Trigger this when</span>
                        </div>
                        <div class="col-8 d-flex align-content-around">
                            <input type="number" name="time_value" min="1" @input="debounceTimeBased"
                                   v-model="form.time_based.time_value" class="form-control-sm border-1 br-5 mr-2">

                            <select name="time_unit" class="btn-blue form-control-sm text-white br-5" v-model="form.time_based.time_unit">
                                <option value="minutes">Minutes</option>
                                <option value="hours">Hours</option>
                                <option value="days">Days</option>
                                <option value="weekdays">Weekdays</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-4">
                            <span class="mr-4">After/before</span>
                        </div>
                        <div class="col-8">
                            <select name="time_operator" class="btn-blue form-control-sm text-white br-5" v-model="form.time_based.time_operator" @change="changeSaleBehaviorValue">
                                <option value="after" selected>After</option>
                                <option value="before">Before</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-4">
                            <input type="checkbox" id="time_based_on_the_next" name="time_based_on_the_next" :true-value="1" :false-value="0" class="ml-1"
                                   v-model="form.time_based.on_the_next">
                            <label class="-mb-0 text-grey-darkest text-sm ml-1" for="time_based_on_the_next">On the next</label>
                        </div>
                        <div class="col-8">
                            <select class="btn-blue form-control-sm text-white br-5"
                                    name="starting_day" v-model="form.time_based.starting_day">
                                <option value="Monday">Monday</option>
                                <option value="Tuesday">Tuesday</option>
                                <option value="Wednesday">Wednesday</option>
                                <option value="Thursday">Thursday</option>
                                <option value="Friday">Friday</option>
                                <option v-if="form.time_based.time_unit !== 'weekdays'" value="Saturday">Saturday</option>
                                <option v-if="form.time_based.time_unit !== 'weekdays'" value="Sunday">Sunday</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-4">
                            <input type="checkbox" id="time_based_at_this_time" name="time_based_at_this_time" :true-value="1" :false-value="0" class="ml-1"
                                   v-model="form.time_based.at_this_time">
                            <label class="-mb-0 text-grey-darkest text-sm ml-1" for="time_based_at_this_time">At this time</label>
                        </div>
                        <div class="col-8">
                            <select v-model="form.time_based.starting_time" class="btn-blue form-control-sm text-white br-5"
                                    name="starting_time">
                                <option v-for="(item, index) in times" :value="item.property_name">{{ item.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="mt-3 mb-3" v-if="form.automation_type">
                    <p class="mb-1">2. Select an object <span class="required-field">*</span></p>
                    <div>
                        <button class="btn btn-primary mr-2" :class="getSelectedClass('project')" @click="changeSelected('object', 'project')">Project</button>
                        <button class="btn btn-primary mr-2" :class="getSelectedClass('company')" @click="changeSelected('object', 'company')" :disabled="form.time_based.time_operator === 'before'">Company</button>
                        <button class="btn btn-primary mr-2" :class="getSelectedClass('contact')" @click="changeSelected('object', 'contact')">Contact</button>
<!--                        <button class="btn btn-primary" :class="getSelectedClass('sequence')" @click="changeSelected('object', 'sequence')" :disabled="form.time_based.time_operator === 'before'">Sequence</button>-->
                    </div>
                </div>
                <div class="mt-3 mb-3" v-if="form.automation_object">
                    <p class="mb-1">3. Select a trigger <span class="required-field">*</span></p>
                    <div v-if="(['project', 'company', 'contact'].includes(form.automation_object))">
                        <button class="btn btn-light-green mr-2" :class="getSelectedClass('created')" @click="changeSelected('trigger', 'created')" :disabled="isButtonDisabled">Created</button>
                        <button class="btn btn-light-green mr-2" :class="getSelectedClass('deleted')" @click="changeSelected('trigger', 'deleted')" :disabled="isButtonDisabled">Deleted</button>
                        <button class="btn btn-light-green mr-2" :class="getSelectedClass('updated')" @click="changeSelected('trigger', 'updated')" :disabled="isButtonDisabled">Update</button>
                        <button class="btn btn-light-green mr-2" :class="getSelectedClass('not_updated')" @click="changeSelected('trigger', 'not_updated')" v-if="form.automation_type === 'time_based' && (['project', 'contact'].includes(form.automation_object))" :disabled="isButtonDisabled">Not Updated</button>
                        <button class="btn btn-light-green mr-2" :class="getSelectedClass('activity_added')" @click="changeSelected('trigger', 'activity_added')" v-if="(['project', 'contact'].includes(form.automation_object))" :disabled="isButtonDisabled">Activity Added</button>
                        <button class="btn btn-light-green mr-2" :class="getSelectedClass('activity_completed')" @click="changeSelected('trigger', 'activity_completed')" v-if="(['project', 'contact'].includes(form.automation_object))" :disabled="isButtonDisabled">Activity Completed</button>
                        <button class="btn btn-light-green mr-2" :class="getSelectedClass('activity_due')" @click="changeSelected('trigger', 'activity_due')" v-if="form.automation_type === 'time_based' && (['project', 'contact'].includes(form.automation_object))">Activity Due</button>
                    </div>
                    <div v-else>
                        <button class="btn btn-light-green mr-2" :class="getSelectedClass('apply')" @click="changeSelected('trigger', 'apply')">Applied</button>
                        <button class="btn btn-light-green mr-2" :class="getSelectedClass('remove')" @click="changeSelected('trigger', 'remove')">Removed</button>
                    </div>
                </div>
                <div class="mt-3 mb-3" v-show="(form.automation_trigger === 'created' || form.automation_trigger === 'updated') && (['project', 'company', 'contact'].includes(form.automation_object))">
                    <p class="mb-1">4. Condition <span v-if="form.automation_trigger !== 'created'" class="required-field">*</span></p>
                    <automation-conditions
                        ref="AutomationConditions"
                        :form="form"
                        :automation="null"
                        :all_codes="all_codes"
                        :allProjectFields="allProjectFields"
                        :allCompanyFields="allCompanyFields"
                        :allContactFields="allContactFields"
                        :dropdown_options="dropdown_options"
                        :dropdown_user_values="dropdown_user_values"
                        :company_types="company_types"
                        :contact_types="contact_types"
                        :team_contact_statuses="team_contact_statuses"
                    >
                    </automation-conditions>
                </div>
                <div class="mt-3 mb-3" v-if="(['not_updated', 'activity_added', 'activity_completed', 'activity_due'].includes(form.automation_trigger))">
                    <p class="mb-1">4. Select a field <span v-if="form.automation_trigger !== 'not_updated'" class="required-field">*</span></p>
                    <div>
                        <button class="btn btn-purple text-white mr-2 capitalize" data-toggle="modal" data-target="#fieldModal" :class="getSelectedClass('field')">{{(this.form.automation_field !== 'empty') ? this.form.automation_field.replace(/_/g, ' ') : 'Field'}}</button>
                    </div>
                </div>
                <div class="mt-3 mb-3" v-if="form.automation_trigger === 'not_updated' && (['project', 'contact'].includes(form.automation_object)) && form.automation_field !== 'empty'">
                    <p class="mb-1">5. Select a field to exclude {{ form.automation_object }}</p>
                    <div>
                        <button class="btn btn-purple text-white mr-2" data-toggle="modal" data-target="#fieldExcludeModal" :class="getSelectedClass('exclude_field')">Field To Exclude</button>
                    </div>
                </div>

                <div class="card w-50 mt-4" v-if="form.exclude_field && form.exclude_field !== 'empty'">
                    <div class="card-header">
                        <h6 class="capitalize"> Excluded field <b>{{ form.exclude_field.replace(/_/g, ' ') }}</b></h6>
                    </div>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item" v-for="(item, index) in filteredFieldsSelectedValues" :key="'excludeValue'+index">
                            <strong class="text-capitalize"> {{ item.code }} </strong>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="mt-5 mb-4">
                <button class="btn btn-light-red mr-2" @click="goToAutomations">Back</button>
                <button class="btn btn-success" @click="goToNext">Next</button>
            </div>
        </div>

        <div v-show="!firstStep">
            <div class="custom-height pb-3">
                <div>
                    <div class="flex flex-column automation-trigger p-1 pb-3 mt-2">
                        <div class="mb-2">
                            <div>Trigger</div>
                        </div>
                        <div class="trigger br-10">
                            When a
                            <button class="btn btn-primary mr-2 capitalize" v-if="form.automation_object">{{ form.automation_object }}</button>
                            <button v-if="['activity_added', 'activity_completed', 'activity_due'].includes(form.automation_trigger) && form.automation_field !== 'empty'" class="btn btn-light-green mr-2 text-capitalize">{{ form.automation_field.replace('_', ' ') }} Activity</button>
                            <span v-if="form.automation_trigger">
                                is
                            <button class="btn btn-light-green mr-4 capitalize">{{form.automation_trigger.replace('activity', '').replace('_', ' ')}}</button>
                                then...
                            </span>
                        </div>
                    </div>
                    <create-edit-automation-action-list
                        :team="team"
                        :automationActions="form.automationActions"
                        :recordDetailFieldLabels="recordDetailFieldLabels"
                        :fieldLabels="fieldLabels"
                    >
                    </create-edit-automation-action-list>
                </div>

                <div v-for="(action, index) in form.automationActions" :key="index" class="card p-3">
                    <div class="mt-3 mb-3 flex justify-content-between">
                        <div>
                            <p class="mb-1">1. Select an action <span class="required-field">*</span></p>
                            <div>
                                <button class="btn btn-light-yellow mr-2" :class="getSelectedClass('action_update', index)" @click="changeSelected('action', 'action_update', index)" :disabled="form.automation_trigger === 'deleted' || form.automation_object === 'sequence'">Update</button>
                                <button class="btn btn-light-yellow mr-2" :class="getSelectedClass('action_email', index)" @click="changeSelected('action', 'action_email', index)">Email</button>
                            </div>
                        </div>
                        <div>
                            <button v-if="form.automationActions.length > 1" class="btn btn-danger" @click="removeAutomationAction(index)">
                                <i class="fa fa-trash" aria-hidden="true"></i> Remove action
                            </button>
                        </div>
                    </div>

                    <div class="mt-3 mb-3" v-if="form.automationActions[index].action">
                        <p class="mb-1">2. Choose an object <span class="required-field">*</span></p>
                        <div>
                            <button class="btn btn-primary mr-2" :class="getSelectedClass('action_project', index)" @click="changeSelected('action_object', 'action_project', index)" :disabled="form.automation_object !== 'project'">Project</button>
                            <button class="btn btn-primary mr-2" :class="getSelectedClass('action_company', index)" @click="changeSelected('action_object', 'action_company', index)" :disabled="form.automationActions[index].action === 'action_update' && form.automation_object !== 'company'" v-if="form.automationActions[index].action === 'action_update'">Company</button>
                            <button class="btn btn-primary mr-2" :class="getSelectedClass('action_contact', index)" @click="changeSelected('action_object', 'action_contact', index)" :disabled="form.automation_object !== 'contact'">Contact</button>
                            <button class="btn btn-primary mr-2" :class="getSelectedClass('action_user', index)" @click="changeSelected('action_object', 'action_user', index)" v-if="form.automationActions[index].action !== 'action_update'">User</button>
                            <button class="btn btn-primary mr-2" :class="getSelectedClass('action_sequence', index)" @click="changeSelected('action_object', 'action_sequence', index)" v-if="form.automation_object === 'contact'" :disabled="form.automationActions[index].action !== 'action_update'">Sequence</button>
                            <button class="btn btn-primary mr-2" :class="getSelectedClass('action_non_user', index)" @click="changeSelected('action_object', 'action_non_user', index)" v-if="form.automationActions[index].action === 'action_email'" :disabled="(['not_updated', 'activity_due'].includes(form.automation_trigger))">Non-User</button>
                        </div>
                    </div>

                    <div class="mt-3 mb-3" v-if="(form.automationActions[index].action === 'action_update' && form.automationActions[index].actionObject && (['action_project', 'action_contact', 'action_company'].includes(form.automationActions[index].actionObject))) || (form.automationActions[index].action !== 'action_update' && (form.automationActions[index].actionObject === 'action_user' || form.automationActions[index].actionObject === 'action_non_user' || form.automationActions[index].actionObject === 'action_project'))">
                        <p class="mb-1">3. Add a filter <span class="required-field">*</span></p>
                        <div>
                            <button v-if="form.automationActions[index].action === 'action_update'" class="btn btn-light-red mr-2 capitalize" @click="openCustomModal('filterActionModal', index)">
                                Add a filter
                            </button>
                            <button v-if="(form.automationActions[index].action === 'action_email' && form.automationActions[index].actionObject === 'action_non_user')" class="btn btn-light-red mr-2" @click="openCustomModal('filterActionNonUserModal', index)">
                                {{ form.automationActions[index].nonUserRecipientEmailAddresses.length > 0 ? form.automationActions[index].nonUserRecipientEmailAddresses.map(item => item.email).join(', ') : 'Add a filter' }}
                            </button>
                            <button v-if="form.automationActions[index].action === 'action_email' && (form.automationActions[index].actionObject === 'action_project' || form.automationActions[index].actionObject === 'action_user')" class="btn btn-light-red mr-2 capitalize" @click="openCustomModal('filterActionModal', index)">
                                {{ form.automationActions[index].emailActionDropDownValues.length > 0 ? form.automationActions[index].emailActionDropDownValues.map(item => item.name).join(', ') : 'Add a filter' }}
                            </button>
                            <p v-if="form.automationActions[index].actionField !== 'empty'" class='mt-2'><span v-if="((form.automationActions[index].actionSalesBehaviorId && form.automationActions[index].actionIsFixedDate !== 'clear_date_time') || !form.automationActions[index].actionSalesBehaviorId)">Set</span> <b class="capitalize">{{ formatActionFieldName(form.automationActions[index].actionField) }}</b> <span v-if="((form.automationActions[index].actionSalesBehaviorId && form.automationActions[index].actionIsFixedDate !== 'clear_date_time') || !form.automationActions[index].actionSalesBehaviorId)">to</span> <b>{{(form.automationActions[index].selectedActionValue) ? form.automationActions[index].selectedActionValue : (form.automationActions[index].actionFieldObject.type === 'date' ? automationActionDate(index) : form.automationActions[index].inputActionValue)}}</b></p>
                        </div>
                    </div>

                    <div class="mt-3 mb-3" v-if="(form.automationActions[index].action === 'action_update' && form.automationActions[index].actionObject === 'action_sequence')">
                        <p class="mb-1">3. Add a Sequence <span class="required-field">*</span></p>
                        <div>
                            <button class="btn btn-primary mr-2 mt-2" @click.stop.prevent="openSequenceModal(index)">{{ (form.automationActions[index].selectedSequenceName) ? form.automationActions[index].selectedSequenceName : 'Sequence'}}</button>
                        </div>
                    </div>

                    <div class="mt-3 mb-3" v-if="form.automationActions[index].action && form.automationActions[index].actionObject && form.automationActions[index].action === 'action_email' && (form.automationActions[index].actionObject === 'action_contact')">
                        <p class="mb-1">3. Add a Template <span class="required-field">*</span></p>
                        <div>
                            <button class="btn btn-primary mr-2 mt-2" @click.stop.prevent="openEmailTemplateModal(index)">{{ (form.automationActions[index].selectedTemplateName) ? form.automationActions[index].selectedTemplateName : 'Template'}}</button>
                        </div>
                    </div>

                    <div class="mt-3 mb-3" v-if="form.automationActions[index].action && form.automationActions[index].actionObject && form.automationActions[index].action === 'action_email' && form.automationActions[index].actionObject !== 'action_contact' && ((typeof form.automationActions[index].actionFieldObject !== 'object' && form.automationActions[index].actionFieldObject) || (form.automationActions[index].nonUserRecipientEmailAddresses.length > 0 && form.automationActions[index].nonUserSenderEmailAddress) || form.automationActions[index].emailActionDropDownValues.length > 0)">
                        <p class="mb-1">4. Add a Template <span class="required-field">*</span></p>
                        <div>
                            <button class="btn btn-primary mr-2 mt-2" @click.stop.prevent="openEmailTemplateModal(index)">{{ (form.automationActions[index].selectedTemplateName) ? form.automationActions[index].selectedTemplateName : 'Template'}}</button>
                        </div>
                    </div>
                </div>

                <div class="my-3">
                    <button class="btn btn-secondary" @click="addNewAction">
                        <i class="fa fa-plus" aria-hidden="true"></i> Add another action
                    </button>
                </div>
            </div>
            <div class="mt-5 mb-4">
                <button class="btn btn-light-red mr-2" @click="goBack">Back</button>
                <button :disabled="disableSaveButton" class="btn btn-success" @click="saveAutomation">Save</button>
            </div>
        </div>

        <div id="timeBasedModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <!-- Modal content-->
                <div class="modal-content schedule-modal">
                    <div class="modal-body text-dark">
                        <h5 class="text-center mb-4">Time Based</h5>
                        <div class="row d-flex align-items-end">
                            <div class="col-4">
                                <span class="text-sm">Trigger this when</span>
                            </div>
                            <div class="col-8 d-flex align-content-around">
                                <input type="number" name="time_value" min="1" @input="debounceTimeBased"
                                       v-model="form.time_based.time_value" class="form-control-sm border-1 br-5 mr-2">

                                <select name="time_unit" class="btn-blue form-control-sm text-white br-5" v-model="form.time_based.time_unit">
                                    <option value="minutes">Minutes</option>
                                    <option value="hours">Hours</option>
                                    <option value="days">Days</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-4">
                                <span class="mr-4">After/before</span>
                            </div>
                            <div class="col-8">
                                <select name="time_operator" class="btn-blue form-control-sm text-white br-5" v-model="form.time_based.time_operator" @change="changeSaleBehaviorValue">
                                    <option value="after" selected>After</option>
                                    <option value="before">Before</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-4">
                                <span class="mr-4">Starting on</span>
                            </div>
                            <div class="col-8">
                                <select class="btn-blue form-control-sm text-white br-5"
                                        name="starting_day" v-model="form.time_based.starting_day">
                                    <option value="Monday">Monday</option>
                                    <option value="Tuesday">Tuesday</option>
                                    <option value="Wednesday">Wednesday</option>
                                    <option value="Thursday">Thursday</option>
                                    <option value="Friday">Friday</option>
                                    <option value="Saturday">Saturday</option>
                                    <option value="Sunday">Sunday</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-4">
                                <span class="mr-4">At this time</span>
                            </div>
                            <div class="col-8">
                                <select v-model="form.time_based.starting_time" class="btn-blue form-control-sm text-white br-5"
                                         name="starting_time">
                                    <option v-for="(item, index) in times" :value="item.property_name">{{ item.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="text-right mt-4">
                        <button class="btn btn-primary" data-dismiss="modal">
                            Save
                        </button>

                    </div>
                </div>
            </div>
        </div>

        <div id="fieldModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
                <!-- Modal content-->
                <div class="modal-content schedule-modal">
                    <div class="modal-body text-dark p-0">
                        <h5 class="text-center mb-2">Select Field</h5>
                        <div class="flex justify-center">
                            <b-form-select v-model="form.automation_field" v-if="form.automation_object === 'project'" class="mb-3" id="project_select" @change="selectField">
                                <b-form-select-option value="empty" id="project_empty1">Please select an option</b-form-select-option>
                                <b-form-select-option v-for="(item, index) in allProjectFields" :value="item.property_name" :key="'project'+index">{{ item.name }}</b-form-select-option>
                            </b-form-select>
                            <b-form-select v-model="form.automation_field" v-if="form.automation_object === 'company'" class="mb-3" id="company_select" @change="selectField">
                                <b-form-select-option value="empty" id="company_empty1">Please select an option</b-form-select-option>
                                <b-form-select-option v-for="(item, index) in allCompanyFields" :value="item.property_name" :key="'company'+index">{{ item.name }}</b-form-select-option>
                            </b-form-select>
                            <b-form-select v-model="form.automation_field" v-if="form.automation_object === 'contact'" class="mb-3" id="contact_select" @change="selectField">
                                <b-form-select-option value="empty" id="contact_empty1">Please select an option</b-form-select-option>
                                <b-form-select-option v-for="(item, index) in allContactFields" :value="item.property_name" :key="'contact'+index">{{ item.name }}</b-form-select-option>
                            </b-form-select>
                        </div>
                        <div class="text-right mt-4">
                            <button class="btn btn-primary" data-dismiss="modal">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="filterActionModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" :class="getFilterActionModalClass(currentAutomationActionIndex)">
                <!-- Modal content-->
                <div class="modal-content schedule-modal p-0">
                    <div class="modal-body text-dark">
                        <h5 class="text-center mb-2">Filter</h5>
                        <div class="flex align-items-top justify-content-between mt-5">

<!--                            if action  == update show field dropdown-->
                            <div v-if="form.automationActions[currentAutomationActionIndex].action === 'action_update'" class="text-center">
                                <b-form-select v-model="form.automationActions[currentAutomationActionIndex].actionField" v-if="form.automationActions[currentAutomationActionIndex].actionObject === 'action_project'" id="action_project_select" @change="actionFieldChange">
                                    <b-form-select-option value="empty" id="action-project-empty">Please select an option</b-form-select-option>
                                    <b-form-select-option v-for="(item, index) in allProjectActionFields" :value="item.property_name" :key="'project'+index">{{ item.name }}</b-form-select-option>
                                </b-form-select>
                                <b-form-select v-model="form.automationActions[currentAutomationActionIndex].actionField" v-if="form.automationActions[currentAutomationActionIndex].actionObject === 'action_company'" id="action_company_select" @change="actionFieldChange">
                                    <b-form-select-option value="empty" id="action-company-empty">Please select an option</b-form-select-option>
                                    <b-form-select-option v-for="(item, index) in allCompanyFields" :value="item.property_name" :key="'company'+index">{{ item.name }}</b-form-select-option>
                                </b-form-select>
                                <b-form-select v-model="form.automationActions[currentAutomationActionIndex].actionField" v-if="form.automationActions[currentAutomationActionIndex].actionObject === 'action_contact'" id="action_contact_select" @change="actionFieldChange">
                                    <b-form-select-option value="empty" id="action-contact-empty">Please select an option</b-form-select-option>
                                    <b-form-select-option v-for="(item, index) in allContactActionFields" :value="item.property_name" :key="'contact'+index">{{ item.name }}</b-form-select-option>
                                </b-form-select>
                            </div>
                            <div v-if="form.automationActions[currentAutomationActionIndex].action === 'action_email'" class="w-100 text-center">

                                <div v-if="form.automationActions[currentAutomationActionIndex].actionObject === 'action_user'">
                                    <multiselect v-model="form.automationActions[currentAutomationActionIndex].emailActionDropDownValues"
                                                 id="teamUsersList"
                                                 tag-placeholder="Press enter to add"
                                                 placeholder="Select..."
                                                 :options="dropdown_user_values"
                                                 :multiple="true"
                                                 track-by="id"
                                                 label="name"
                                                 :taggable="true"
                                                 :close-on-select="false">
                                    </multiselect>
                                </div>

                                <div v-if="form.automationActions[currentAutomationActionIndex].actionObject === 'action_project'">
                                    <multiselect v-model="form.automationActions[currentAutomationActionIndex].emailActionDropDownValues"
                                                 id="teamUsersList"
                                                 tag-placeholder="Press enter to add"
                                                 placeholder="Select..."
                                                 :options="emailActionProjectDropDownValues"
                                                 :multiple="true"
                                                 track-by="id"
                                                 label="name"
                                                 :taggable="true"
                                                 :close-on-select="false">
                                    </multiselect>
                                </div>

<!--                                <b-form-select v-model="form.action_field_object" multiple class="form-control-sm" v-if="form.action_object === 'action_user'">-->
<!--                                    <b-form-select-option value="empty" id="action-user-empty0">Please select an option</b-form-select-option>-->
<!--                                    <b-form-select-option v-for="(item, index) in dropdown_user_values" :value="item.id" :key="'user'+index">{{ item.name }}</b-form-select-option>-->
<!--                                </b-form-select>-->
<!--                                <b-form-select v-model="form.project_email_user" multiple class="form-control-sm" v-if="form.action_object === 'action_project'" @change="selectedProjectEmailOption">-->
<!--                                    <b-form-select-option value="project_contact" id="project_contact">Project Contact</b-form-select-option>-->
<!--                                    <b-form-select-option value="account_manager" id="account_manager">Account Manager</b-form-select-option>-->
<!--                                    <b-form-select-option value="estimator" id="estimator">Estimator</b-form-select-option>-->
<!--                                    <b-form-select-option value="take_off_person" id="take_off_person">Take Off Person</b-form-select-option>-->
<!--                                    <b-form-select-option value="company_contact" id="company_contact">Company Contact - First Contact</b-form-select-option>-->
<!--                                </b-form-select>-->

<!--                                <b-form-select v-model="form.action_field_object" class="form-control-sm" v-if="form.action_object === 'action_project'">-->
<!--                                    <b-form-select-option value="empty" id="action-project-empty0">Please select an option</b-form-select-option>-->
<!--                                    <b-form-select-option v-for="(item, index) in project_options" :value="item.id" :key="'user'+index">{{ item.name }}</b-form-select-option>-->
<!--                                </b-form-select>-->

<!--                                <b-form-select v-model="form.action_field_object" class="form-control-sm" v-if="form.action_object === 'action_company'">-->
<!--                                    <b-form-select-option value="empty" id="action-company-empty0">Please select an option</b-form-select-option>-->
<!--                                    <b-form-select-option v-for="(item, index) in company_options" :value="item.id" :key="'user'+index">{{ item.name }}</b-form-select-option>-->
<!--                                </b-form-select>-->

<!--                                <b-form-select v-model="form.action_field_object" class="form-control-sm" v-if="form.action_object === 'action_contact'">-->
<!--                                    <b-form-select-option value="empty" id="action-contact-empty0">Please select an option</b-form-select-option>-->
<!--                                    <b-form-select-option v-for="(item, index) in contact_options" :value="item.id" :key="'user'+index">{{ item.name }}</b-form-select-option>-->
<!--                                </b-form-select>-->
                            </div>

                            <div v-if="form.automationActions[currentAutomationActionIndex].action === 'action_update' && form.automationActions[currentAutomationActionIndex].actionFieldObject.type === 'date'" class="d-flex flex-column text-center">
                                <b-form-select class="form-control"  v-model="form.automationActions[currentAutomationActionIndex].actionIsFixedDate" @change="() => form.automationActions[currentAutomationActionIndex].inputActionValue = null">
                                    <b-form-select-option value="empty" id="action_is_fixed_date">Please select type</b-form-select-option>
                                    <b-form-select-option value="fixed" key="fixed" >Fixed Date</b-form-select-option>
                                    <b-form-select-option value="not_fixed" key="not_fixed" >No. of days</b-form-select-option>
                                    <b-form-select-option v-if="form.automationActions[currentAutomationActionIndex].actionFieldObject.is_sales_behavior" value="clear_date_time" key="clear_date_time" >Clear Date & Time</b-form-select-option>
                                </b-form-select>

                                <small v-if="form.automationActions[currentAutomationActionIndex].actionIsFixedDate === 'not_fixed'">{{form.automationActions[currentAutomationActionIndex].actionField.replace(/_/g, ' ')}} will be set</small>
                                <small v-if="form.automationActions[currentAutomationActionIndex].actionIsFixedDate === 'not_fixed'">{{actionDate ? actionDate : ''}}</small>
                                <small v-if="form.automationActions[currentAutomationActionIndex].actionIsFixedDate === 'clear_date_time'">Sales Activity date and time will be cleared out.</small>

                            </div>

                            <div v-if="form.automationActions[currentAutomationActionIndex].action === 'action_update' && form.automationActions[currentAutomationActionIndex].actionIsFixedDate !== 'clear_date_time'" class="text-center">

                                <input class="form-control" type="text" v-if="form.automationActions[currentAutomationActionIndex].actionFieldObject.type === 'text'" v-model="form.automationActions[currentAutomationActionIndex].inputActionValue" key="text">

                                <b-form-select class="form-control" v-if="form.automationActions[currentAutomationActionIndex].actionFieldObject.type === 'dropdown' && !form.automationActions[currentAutomationActionIndex].actionFieldObject.is_custom_field" v-model="form.automationActions[currentAutomationActionIndex].selectedActionObject" @change="selectedActionOption">
                                    <b-form-select-option value="empty" id="action_dropdown">Please select an option</b-form-select-option>
                                    <b-form-select-option v-for="(item, index) in action_dropdown_options" :value="item" :key="'filter'+index" >{{ item.code }}</b-form-select-option>
                                </b-form-select>
                                <b-form-select class="form-control" v-if="form.automationActions[currentAutomationActionIndex].actionFieldObject.type === 'dropdown' && form.automationActions[currentAutomationActionIndex].actionFieldObject.is_custom_field" v-model="form.automationActions[currentAutomationActionIndex].selectedActionObject" @change="selectedActionOption">
                                    <b-form-select-option value="empty" id="action_dropdown">Please select an option</b-form-select-option>
                                    <b-form-select-option v-for="(item, index) in action_dropdown_options" :value="item" :key="'filter'+index" >{{ item.name }}</b-form-select-option>
                                </b-form-select>

                                <b-form-select class="form-control" v-if="form.automationActions[currentAutomationActionIndex].actionFieldObject.type === 'user'" v-model="form.automationActions[currentAutomationActionIndex].selectedActionObject" @change="selectedActionUserOption">
                                    <b-form-select-option value="empty" id="action_user_empty">Please select an option</b-form-select-option>
                                    <b-form-select-option v-for="(item, index) in dropdown_user_values" :value="item" :key="'user'+index">{{ item.name }}</b-form-select-option>
                                </b-form-select>

                                <input type="text" name="contact_phone"
                                       v-if="form.automationActions[currentAutomationActionIndex].actionFieldObject.type === 'phone'"
                                       key="phone"
                                       v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                                       id="action_contact_phone"
                                       class="form-control"
                                       v-model="form.automationActions[currentAutomationActionIndex].inputActionValue">

                                <currency-input
                                    v-if="form.automationActions[currentAutomationActionIndex].actionFieldObject.type === 'money'"
                                    id="action_contract_amount"
                                    name="contract_amount"
                                    locale="us"
                                    :currency="null"
                                    class="form-control"
                                    v-model="form.automationActions[currentAutomationActionIndex].inputActionValue">
                                </currency-input>


                                <datepicker
                                    v-if="form.automationActions[currentAutomationActionIndex].actionFieldObject.type === 'date' && form.automationActions[currentAutomationActionIndex].actionIsFixedDate === 'fixed'"
                                    :format="'MM/dd/yyyy'" :use-utc="true"
                                    wrapper-class="form-control"
                                    v-model="form.automationActions[currentAutomationActionIndex].inputActionValue"
                                    input-class="date-picker-ui"
                                ></datepicker>

                                <input type="number" min="1" name="action_date_type"
                                       v-if="form.automationActions[currentAutomationActionIndex].actionFieldObject.type === 'date' && form.automationActions[currentAutomationActionIndex].actionIsFixedDate === 'not_fixed'"
                                       class="form-control"
                                       v-model="form.automationActions[currentAutomationActionIndex].inputActionValue">
                            </div>

                            <div v-if="team.has_calendar_access && form.automationActions[currentAutomationActionIndex].actionFieldObject.is_sales_behavior && form.automationActions[currentAutomationActionIndex].actionIsFixedDate !== 'clear_date_time'" class="text-center" :class="(showTimeSelectionBar ? 'custom-w-30' : '')">
                                <button type="button" class="btn custom-btn-shadow" v-if="!showTimeSelectionBar && form.automationActions[currentAutomationActionIndex].inputActionValue" @click="() => showTimeSelectionBar = !showTimeSelectionBar">
                                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                                </button>
                                <div class="flex sales-behavior-time-selection" v-if="showTimeSelectionBar && form.automationActions[currentAutomationActionIndex].inputActionValue">
                                    <span class="my-1 mx-2">at</span>
                                    <div class="form-inline d-flex dropdown">
                                        <div class="btn-group custom-w-30" role="group">
                                            <input class="form-control sales-behavior-time-input w-100" type="text" placeholder="Search" data-toggle="dropdown" readonly v-model="form.automationActions[currentAutomationActionIndex].salesBehaviorHour">
                                            <div class="dropdown-menu dropdown-menu-wide">
                                                <span v-for="item in hoursArray" class="dropdown-item" :class="form.automationActions[currentAutomationActionIndex].salesBehaviorHour === item ? 'bg-primary text-white' : ''" tabindex="-1" href="#" @click.prevent="form.automationActions[currentAutomationActionIndex].salesBehaviorHour = item">{{ item }}</span>
                                            </div>
                                        </div>
                                        <div class="btn-group custom-w-10 justify-content-center" role="group">
                                            <span>:</span>
                                        </div>
                                        <div class="btn-group custom-w-30" role="group">
                                            <input class="form-control sales-behavior-time-input w-100" type="text" placeholder="Search" data-toggle="dropdown" readonly v-model="form.automationActions[currentAutomationActionIndex].salesBehaviorMinute">
                                            <div class="dropdown-menu dropdown-menu-wide">
                                                <span v-for="item in minutesArray" class="dropdown-item" :class="form.automationActions[currentAutomationActionIndex].salesBehaviorMinute === item ? 'bg-primary text-white' : ''" tabindex="-1" href="#" @click.prevent="form.automationActions[currentAutomationActionIndex].salesBehaviorMinute = item">{{ item }}</span>
                                            </div>
                                        </div>
                                        <div class="btn-group custom-w-30" role="group">
                                            <input class="form-control sales-behavior-time-input w-100" type="text" placeholder="Search" id="menu1" data-toggle="dropdown" readonly v-model="form.automationActions[currentAutomationActionIndex].salesBehaviorAMPM">
                                            <div class="dropdown-menu dropdown-menu-wide">
                                                <span class="dropdown-item" :class="form.automationActions[currentAutomationActionIndex].salesBehaviorAMPM === 'AM' ? 'bg-primary text-white' : ''" tabindex="-1" href="#" @click.prevent="form.automationActions[currentAutomationActionIndex].salesBehaviorAMPM = 'AM'">AM</span>
                                                <span class="dropdown-item" :class="form.automationActions[currentAutomationActionIndex].salesBehaviorAMPM === 'PM' ? 'bg-primary text-white' : ''" tabindex="-1" href="#" @click.prevent="form.automationActions[currentAutomationActionIndex].salesBehaviorAMPM = 'PM'">PM</span>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="button" class="btn" @click="() => showTimeSelectionBar = !showTimeSelectionBar">
                                        <i class="fa fa-remove" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>

                        </div>
                        <div class="text-right mt-5">
                            <button class="btn btn-primary" data-dismiss="modal">
                                Save
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="filterActionNonUserModal" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content schedule-modal">
                    <div class="modal-body text-dark">
                        <h4 class="text-center mb-3">Input Sender & Recipient(s)
                            <button type="button" class="close" @click="closeFilterActionNonUserModal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </h4>
                        <div class="form-group mb-3">
                            <label class="text-grey-darkest text-sm">Sender Email Address <span class="text-danger">*</span></label>
                            <select class="form-control" v-model="form.automationActions[currentAutomationActionIndex].nonUserSenderEmailAddress">
                                <option value="">Select email address</option>
                                <option v-for="item in senderEmailAddressOptions" :value="item">{{ item }}</option>
                            </select>
                        </div>

                        <div class="form-group mb-3">
                            <label class="text-grey-darkest text-sm">Recipients <span class="text-danger">*</span></label>
                            <multiselect v-model="form.automationActions[currentAutomationActionIndex].nonUserRecipientEmailAddresses"
                                         id="recipientEmailSelected"
                                         tag-placeholder="Press enter to add"
                                         placeholder="Add an email"
                                         :options="recipientEmailAddressOptions"
                                         :multiple="true"
                                         track-by="email"
                                         label="email"
                                         :taggable="true"
                                         :close-on-select="false"
                                         @tag="addRecipient">
                                <template v-slot:noOptions>
                                    <span style="display:none"> List is empty. </span>
                                </template>
                            </multiselect>
                        </div>

                        <div class="text-right mt-3">
                            <button class="btn btn-primary" data-dismiss="modal" type="button">
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="fieldExcludeModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content schedule-modal p-0">
                    <div class="modal-body text-dark">
                        <h5 class="text-center mb-2">Select Field</h5>
                        <div class="flex align-items-center justify-content-between mt-5">

                            <div class="w-100 text-center">
                                <b-form-select v-model="form.exclude_field" v-if="form.automation_object === 'project'" id="exclude_project_select" @change="selectExcludeField">
                                    <b-form-select-option value="empty" id="project-exclude">Please select an option</b-form-select-option>
                                    <b-form-select-option v-for="(item, index) in filteredProjectFields" :value="item.property_name" :key="'project'+index">{{ item.name }}</b-form-select-option>
                                </b-form-select>
                                <b-form-select v-model="form.exclude_field" v-if="form.automation_object === 'contact'" id="exclude_contact_select" @change="selectExcludeField">
                                    <b-form-select-option value="empty" id="contact-exclude">Please select an option</b-form-select-option>
                                    <b-form-select-option v-for="(item, index) in filteredContactFields" :value="item.property_name" :key="'contact'+index">{{ item.name }}</b-form-select-option>
                                </b-form-select>
                            </div>

                            <div class="w-100 text-center ml-2">
                                <multiselect
                                    v-model="filteredFieldsSelectedValues"
                                    id="exclude_action_dropdown"
                                    :options="exclude_dropdown_options"
                                    :multiple="true"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    :preserve-search="true"
                                    open-direction="below"
                                    placeholder="Select Options"
                                    label="code"
                                    track-by="id"
                                    @select="filteredFieldsSelected"
                                >
                                </multiselect>
                            </div>

                        </div>
                        <div class="text-right mt-5">
                            <button class="btn btn-primary" data-dismiss="modal" type="button">
                                Save
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <email-template-modal-ckeditor ref="EmailTemplateModal" v-on:addTemplateToEmail="selectTemplate" :allFields="templateFields" :isAutomation="true" :automationObject="form.automation_object"></email-template-modal-ckeditor>
        <sequence-modal ref="EmailSequenceModal" :project="null" v-on:addSequenceToContactEmail="selectSequence" :selectedContactForSequence="null" :allFields="contactAllFields" :subSuffix="null"></sequence-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import ProjectField from "../../assets/fields-data/project-fields.json";
import ProjectRecordDetailFields from "../../assets/fields-data/project-record-detail-fields.json";
import ProjectDataFields from "../../assets/fields-data/project-data-fields.json";
import CompanyField from "../../assets/fields-data/company-fields.json";
import ContactField from "../../assets/fields-data/contact-fields.json";
import TemplateFields from "../../assets/fields-data/automation-template-fields.json";
import Times from "../../assets/fields-data/times.json";
import Datepicker from 'vuejs-datepicker';
import {CurrencyInput} from "vue-currency-input";
import Swal from "sweetalert2";
import moment from "moment";
import AutomationConditions from "./utils/automation-conditions.vue";
import CreateEditAutomationActionList from "./utils/create-edit-automation-action-list.vue";

const multiActionObject = {
    action: null,
    actionObject: null,
    actionField: null,
    inputActionValue: null,
    automationTemplateId: null,
    emailSequenceId: null,
    selectedSequenceName: null,
    emailActionDropDownValues: [],
    nonUserSenderName: null,
    nonUserSenderEmailAddress: null,
    nonUserRecipientEmailAddresses: [],
    selectedActionValue: null,
    selectedTemplateName: null,
    selectedActionObject: null,
    actionCustomFieldId: null,
    actionIsRecordDetailCustomField: false,
    actionSalesBehaviorId: null,
    actionIsFixedDate: "fixed",
    salesBehaviorHour: '12',
    salesBehaviorMinute: '00',
    salesBehaviorAMPM: 'AM',
    fieldObject: {
        name: '',
        property_name:'',
        type: 'text'
    },
    actionFieldObject: {
        name: '',
        property_name:'',
        type: 'text'
    }
};
    export default {
        name:'create-automations',
        components: {CreateEditAutomationActionList, AutomationConditions, Datepicker, CurrencyInput, Multiselect},
        props: ['userRole', 'nonUserSenderEmails', 'team', 'fieldLabels', 'projectDataFieldVisibility', 'recordDetailFieldLabels'],
        data() {
            return {
                // project_fields:ProjectField,
                // company_fields:CompanyField,
                // contact_fields:ContactField,
                times: Times,
                firstStep: true,
                dropdown_user_values:null,
                dropdown_options: [],
                action_dropdown_options: [],
                exclude_dropdown_options: [],
                // project_options: [],
                sales_behaviours: [],
                // company_options: [],
                // contact_options: [],
                company_types: [],
                contact_types: [],
                all_codes: [],
                form: {
                    name: null,
                    automation_type:null,
                    automation_object:null,
                    automation_trigger:null,
                    automation_field:'empty',
                    trigger_operator: 'equal to',
                    action_field:'empty',
                    action_is_fixed_date: "fixed",
                    automation_filter:null,
                    input_value: null,
                    input_value_extra: null,
                    input_action_value: null,
                    action: null,
                    action_object: null,
                    field_object: {
                        name: '',
                        property_name:'',
                        type: 'text'
                    },
                    action_field_object: {
                        name: '',
                        property_name:'',
                        type: 'text'
                    },
                    time_based:{
                        time_value:null,
                        time_unit:"minutes",
                        time_operator:"after",
                        // time_filter:"empty",
                        starting_day:"Monday",
                        starting_time:Times[0].property_name,
                        on_the_next: 0,
                        at_this_time: 0
                    },
                    automation_template_id: null,
                    email_sequence_id: null,
                    automation_exclude_field: 'empty',
                    exclude_field: 'empty',
                    exclude_field_values: [],
                    automation_conditions: [],
                    project_email_user: null,
                    action_custom_field_id: null,
                    action_sales_behavior_id: null,
                    is_shared: false,
                    nonUserSenderName: null,
                    nonUserSenderEmailAddress: null,
                    nonUserRecipientEmailAddresses: [],
                    emailActionDropDownValues: [],
                    automationActions: [_.cloneDeep(multiActionObject)],
                    userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
                },
                pagination: {
                    data: [],
                    meta: {},
                    links: {},
                },
                filteredFieldsSelectedValues: [],
                disableSaveButton: false,
                selectedTemplateName: null,
                selectedActionValue: null,
                selectedActionObject: null,
                team_contact_statuses: [],
                selectedProjectEmailType: null,
                project_custom_fields: [],
                company_custom_fields: [],
                contact_custom_fields: [],
                customFields: [],
                eligibleUserRolesForCompanyAutomation: ['owner', 'admin', 'administrative'],
                contactAllFields: [
                    {
                        id: 0,
                        button: 'addYourName',
                        text: 'My Name',
                        buttonCode: 'replaceYourName'
                    },
                    {
                        id: 1,
                        button: 'addName',
                        text: 'Name',
                        buttonCode: 'replaceName'
                    },
                    {
                        id: 2,
                        button: 'addPhone',
                        text: 'Phone',
                        buttonCode: 'replacePhone'
                    },
                    {
                        id: 3,
                        button: 'addEmail',
                        text: 'Email',
                        buttonCode: 'replaceEmail'
                    },
                    {
                        id: 4,
                        button: 'addCompanyName',
                        text: 'Company Name',
                        buttonCode: 'replaceCompanyName'
                    },
                    {
                        id: 5,
                        button: 'addTitle',
                        text: 'Title',
                        buttonCode: 'replaceTitle'
                    },
                    {
                        id: 6,
                        button: 'addType',
                        text: 'Type',
                        buttonCode: 'replaceType'
                    },
                    {
                        id: 7,
                        button: 'addFollowUp',
                        text: 'Follow Up',
                        buttonCode: 'replaceFollowUp'
                    },
                    {
                        id: 8,
                        button: 'addLastUpdated',
                        text: 'Last Updated',
                        buttonCode: 'replaceLastUpdated'
                    }
                ],
                selectedSequenceName: null,
                senderEmailAddressOptions: this.nonUserSenderEmails,
                recipientEmailAddressOptions: [],
                emailActionProjectDropDownValues: [
                    {
                        id: 'project_contact',
                        name: 'Project Contact'
                    },
                    {
                        id: 'account_manager',
                        name: this.getFieldLabel(this.fieldLabels, 'account-manager')
                    },
                    {
                        id: 'estimator',
                        name: this.getFieldLabel(this.fieldLabels, 'estimator')
                    },
                    {
                        id: 'take_off_person',
                        name: this.getFieldLabel(this.fieldLabels, 'take-off-person')
                    },
                    {
                        id: 'company_contact',
                        name: 'Company Contact - First Contact'
                    },
                ],
                currentAutomationActionIndex: 0,
                showTimeSelectionBar: false,
                hoursArray: [],
                minutesArray: [],
                automationNameAlreadyExists: false,
                recordDetailCustomFields: []
            }
        },
        created() {
            this.fetchCodes();
            this.fetchGeneralData();
            this.checkAutomationAlreadyCompanyShared();
            this.createHoursMinutesData();
        },
        mounted() {
            this.fetchCustomFields();
        },
        watch: {
            filteredFieldsSelectedValues(val) {
                if(val) {
                    const self = this;
                    self.form.exclude_field_values = val.map(obj => obj.id);
                }
            },
            'form.automation_field': function(newVal, oldVal) {
                if(oldVal !== 'empty') {
                    const self = this;
                    self.form.automation_exclude_field = 'empty';
                    self.form.exclude_field = null;
                    self.filteredFieldsSelectedValues = null;
                    self.form.exclude_field_values = null;
                }
            }
        },
        methods: {
            changeSaleBehaviorValue(val) {
                const self = this;
                self.form.automation_object = null;
                self.form.automation_trigger = null;
                self.form.automation_conditions = [];
                self.$refs.AutomationConditions.finalConditions = [];

                // if(self.form.time_based.time_operator === 'before') {
                //     self.form.time_based.time_filter = 'due_date'
                // }else{
                //     self.form.time_based.time_filter = 'empty'
                // }
            },
            fetchCodes() {
                const self = this;
                axios.get(route('api.project.codes')).then(({data}) => {
                    this.all_codes = data;
                    self.dropdown_user_values = data.users
                });
            },
            fetchGeneralData() {
                const self = this;
                axios.get(route('automation.get-data')).then(({data}) => {
                    self.company_types = data.company_types;
                    self.contact_types = data.contact_types;
                    self.team_contact_statuses = data.team_contact_statuses;

                    self.sales_behaviours = data.sales_behaviours.map( x =>({ id: x.id, name: x.name, property_name: x.name.toLowerCase()
                            .replace(/ /g, '_')
                            .replace(/-/g, '_')
                            .replace(/@/g, '_at_')
                            .replace(/[^\w_]+/g, '')
                            .replace(/_+/g, '_'),type: 'date', is_sales_behavior: true}));
                    self.contact_activities = data.contact_activities.map( x =>({ id: x.id, name: x.name, property_name: x.name.toLowerCase()
                            .replace(/ /g, '_')
                            .replace(/-/g, '_')
                            .replace(/@/g, '_at_')
                            .replace(/[^\w_]+/g, '')
                            .replace(/_+/g, '_'),type: 'date', is_sales_behavior: true}));

                    self.project_custom_fields      = data.project_custom_fields;
                    self.company_custom_fields      = data.company_custom_fields;
                    self.contact_custom_fields      = data.contact_custom_fields;
                    self.recordDetailCustomFields   = data.recordDetailCustomFields;
                });
            },
            saveSelectField:function (){
                $("#fieldModal").modal("hide");
            },
            changeSelected:function (type, val, actionIndex = null) {
                const self = this;

                switch(type) {
                    case 'automation_type':
                        self.form.automation_type = val
                        self.form.automation_object = null
                        self.form.automation_trigger = null
                        self.form.automation_field = 'empty'
                        self.form.input_value = null
                        self.form.action = null
                        self.form.action_object = null
                        self.form.time_based.time_value = null
                        self.form.time_based.time_unit = 'minutes'
                        self.form.time_based.time_operator = 'after'
                        // self.form.time_based.time_filter = 'empty'
                        self.form.time_based.starting_day = 'Monday'
                        self.form.time_based.starting_time = '12:00 AM'
                        self.form.automation_exclude_field = 'empty'
                        self.form.field_object = {
                            name: '',
                            property_name:'',
                            type: 'text'
                        }
                        self.filteredFieldsSelectedValues = null
                        self.form.exclude_field = null
                        self.form.exclude_field_values = null
                        self.form.automation_conditions = [];
                        self.form.project_email_user = null;
                        self.$refs.AutomationConditions.finalConditions = [];
                        break;
                    case 'object':
                        self.form.automation_object = val
                        self.form.automation_trigger = null
                        self.form.automation_field = 'empty'
                        self.form.input_value = null
                        self.form.action = null
                        self.form.action_object = null
                        self.form.automation_exclude_field = 'empty'
                        self.form.field_object = {
                            name: '',
                            property_name:'',
                            type: 'text'
                        }
                        self.filteredFieldsSelectedValues = null
                        self.form.exclude_field = null
                        self.form.exclude_field_values = null
                        self.form.automation_conditions = [];
                        self.form.project_email_user = null;
                        self.resetAutomationActions();
                        self.$refs.AutomationConditions.finalConditions = [];
                        break;
                    case 'trigger':
                        self.form.automation_trigger = val
                        self.form.automation_field = 'empty'
                        self.form.input_value = null
                        self.form.action = null
                        self.form.action_object = null
                        self.form.automation_exclude_field = 'empty'
                        self.form.field_object = {
                            name: '',
                            property_name:'',
                            type: 'text'
                        }
                        self.filteredFieldsSelectedValues = null
                        self.form.exclude_field = null
                        self.form.exclude_field_values = null
                        self.form.automation_conditions = [];
                        self.form.project_email_user = null;
                        self.$refs.AutomationConditions.finalConditions = [];

                        break;
                    case 'action':
                        if(actionIndex !== null) {
                            self.form.automationActions[actionIndex].action = val;
                            self.form.automationActions[actionIndex].actionObject = null;
                            self.form.automationActions[actionIndex].inputActionValue = null;
                            self.form.automationActions[actionIndex].actionField = 'empty';
                            self.form.automationActions[actionIndex].actionFieldObject = {
                                name: '',
                                property_name:'',
                                type: 'text'
                            };
                            self.form.automationActions[actionIndex].automationTemplateId = null;
                            self.form.automationActions[actionIndex].selectedTemplateName = null;
                        }
                        break;
                    case 'action_object':
                        if(actionIndex !== null) {
                            self.form.automationActions[actionIndex].actionObject = val;
                            self.form.automationActions[actionIndex].inputActionValue = null;
                            self.form.automationActions[actionIndex].actionField = 'empty';
                            self.form.automationActions[actionIndex].emailSequenceId = null;
                            self.form.automationActions[actionIndex].selectedSequenceName = null;
                            self.form.automationActions[actionIndex].actionFieldObject = {
                                name: '',
                                property_name:'',
                                type: 'text'
                            };
                            self.form.automationActions[actionIndex].emailActionDropDownValues = [];
                            self.form.automationActions[actionIndex].automationTemplateId = null;
                            self.form.automationActions[actionIndex].selectedTemplateName = null;
                        }
                        break;
                }
            },
            getSelectedClass:function (val, actionIndex = null) {
                const self = this;
                if(self.form.automation_type === val){
                    return 'selected_button'
                }
                if(self.form.automation_object === val){
                    return 'selected_button'
                }
                if(self.form.automation_trigger === val){
                    return 'selected_button'
                }
                if(self.form.automation_exclude_field === val){
                    return 'selected_button'
                }
                if(val === 'field' && self.form.automation_field !== 'empty'){
                    return 'selected_button'
                }
                if(self.form.automation_filter === val){
                    return 'selected_button'
                }
                if(actionIndex !== null && self.form.automationActions[actionIndex].action === val) {
                    return 'selected_button'
                }
                if(actionIndex !== null && self.form.automationActions[actionIndex].actionObject === val){
                    return 'selected_button'
                }
                return ''

            },
            goToNext(){
                const isValid = this.validateCreateFields('next');
                if(!isValid) {
                    return false
                }
                this.firstStep = false;
            },
            goBack() {
                this.firstStep = true;
            },
            goToAutomations() {
                window.location = route('automation.index');
            },
            setFieldObject(fields, item) {
                const self = this;
                self.form.input_value = null;
                let fieldObject = fields.find(element => element.property_name === item);
                if(fieldObject){
                    self.form.field_object = fieldObject;
                }else{
                    self.form.field_object = {
                        name: '',
                        property_name:'',
                        type: 'text'
                    }
                }
            },
            selectField(item) {
                const self = this;

                switch(self.form.automation_object) {
                    case 'project':
                        self.setFieldObject(self.allProjectFields, item);
                        break;
                    case 'company':
                        self.setFieldObject(self.allCompanyFields, item);
                        break;
                    case 'contact':
                        self.setFieldObject(self.allContactFields, item);
                        break;
                }

                switch (self.form.field_object.property_name) {
                    case 'sales_status_id':
                        self.dropdown_options = self.all_codes.sales_status
                        break;
                    case 'marketing_status_id':
                        self.dropdown_options = self.all_codes.marketing_status
                        break;
                    case 'lead_from_id':
                        self.dropdown_options = self.all_codes.lead_from
                        break;
                    case 'client_profile_id':
                        self.dropdown_options = self.all_codes.client_profile
                        break;
                    case 'contract_type_id':
                        self.dropdown_options = self.all_codes.contract_type
                        break;
                    case 'office_id':
                        self.dropdown_options = self.all_codes.office
                        break;
                    case 'products_and_services_id':
                        self.dropdown_options = self.all_codes.products_and_services
                        break;
                    case 'company_types_id':
                        self.dropdown_options = self.company_types
                        break;
                    case 'contact_types_id':
                        self.dropdown_options = self.contact_types
                        break;
                    case 'team_contact_status':
                        self.dropdown_options = self.team_contact_statuses
                        break;
                }

                if(self.form.field_object.is_custom_field && ['user', 'dropdown'].includes(self.form.field_object.type)){
                    self.dropdown_options = self.form.field_object.custom_field_options
                }

            },
            selectExcludeField() {
                const self = this;
                if(self.form.automation_exclude_field !== 'empty') {
                    self.filteredFieldsSelectedValues = null;
                    self.form.exclude_field_values = null;
                }

                switch (self.form.exclude_field) {
                    case 'sales_status_id':
                        self.exclude_dropdown_options = self.all_codes.sales_status
                        break;
                    case 'marketing_status_id':
                        self.exclude_dropdown_options = self.all_codes.marketing_status
                        break;
                    case 'lead_from_id':
                        self.exclude_dropdown_options = self.all_codes.lead_from
                        break;
                    case 'client_profile_id':
                        self.exclude_dropdown_options = self.all_codes.client_profile
                        break;
                    case 'contract_type_id':
                        self.exclude_dropdown_options = self.all_codes.contract_type
                        break;
                    case 'office_id':
                        self.exclude_dropdown_options = self.all_codes.office
                        break;
                    case 'products_and_services_id':
                        self.exclude_dropdown_options = self.all_codes.products_and_services
                        break;
                    case 'company_types_id':
                        self.exclude_dropdown_options = self.company_types
                        break;
                    case 'contact_types_id':
                        self.exclude_dropdown_options = self.contact_types
                        break;
                    case 'team_contact_status':
                        self.exclude_dropdown_options = self.team_contact_statuses
                        break;
                }
            },
            setActionFieldObject(fields, item) {
                const self = this;
                let action_field_object = fields.find(element => element.property_name === item);
                self.form.automationActions[self.currentAutomationActionIndex].actionFieldObject = action_field_object ? action_field_object : { name: '', property_name:'', type: 'text'}
                self.form.automationActions[self.currentAutomationActionIndex].actionCustomFieldId = action_field_object.is_custom_field ? action_field_object.id : null;
                self.form.automationActions[self.currentAutomationActionIndex].actionIsRecordDetailCustomField = action_field_object.is_record_detail_custom_field ? action_field_object.is_record_detail_custom_field : false;
                self.form.automationActions[self.currentAutomationActionIndex].actionSalesBehaviorId = action_field_object.is_sales_behavior ? action_field_object.id : null
            },
            actionFieldChange(item) {
                const self = this;
                self.showTimeSelectionBar = false;
                self.form.automationActions[self.currentAutomationActionIndex].selectedActionValue = null;
                self.form.automationActions[self.currentAutomationActionIndex].inputActionValue = null;
                self.form.automationActions[self.currentAutomationActionIndex].selectedActionObject = null;
                self.form.automationActions[self.currentAutomationActionIndex].actionIsFixedDate = "fixed";
                switch(self.form.automationActions[self.currentAutomationActionIndex].actionObject) {
                    case 'action_project':
                        self.setActionFieldObject(self.allProjectActionFields, item);
                        break;
                    case 'action_company':
                        self.setActionFieldObject(self.allCompanyFields, item);
                        break;
                    case 'action_contact':
                        self.setActionFieldObject(self.allContactActionFields, item);
                        break;
                }

                switch (self.form.automationActions[self.currentAutomationActionIndex].actionFieldObject.property_name) {
                    case 'sales_status_id':
                        self.action_dropdown_options = self.all_codes.sales_status
                        break;
                    case 'marketing_status_id':
                        self.action_dropdown_options = self.all_codes.marketing_status
                        break;
                    case 'lead_from_id':
                        self.action_dropdown_options = self.all_codes.lead_from
                        break;
                    case 'client_profile_id':
                        self.action_dropdown_options = self.all_codes.client_profile
                        break;
                    case 'contract_type_id':
                        self.action_dropdown_options = self.all_codes.contract_type
                        break;
                    case 'office_id':
                        self.action_dropdown_options = self.all_codes.office
                        break;
                    case 'products_and_services_id':
                        self.action_dropdown_options = self.all_codes.products_and_services
                        break;
                    case 'company_types_id':
                        self.action_dropdown_options = self.company_types
                        break;
                    case 'contact_types_id':
                        self.action_dropdown_options = self.contact_types
                        break;
                    case 'team_contact_status':
                        self.action_dropdown_options = self.team_contact_statuses
                        break;
                }

                if(self.form.automationActions[self.currentAutomationActionIndex].actionFieldObject.is_custom_field && ['user', 'dropdown'].includes(self.form.automationActions[self.currentAutomationActionIndex].actionFieldObject.type)){
                    self.action_dropdown_options = self.form.automationActions[self.currentAutomationActionIndex].actionFieldObject.custom_field_options;
                    self.form.automationActions[self.currentAutomationActionIndex].actionFieldObject.custom_field_options = [];
                }
            },
            async saveAutomation() {
                const self = this;
                self.disableSaveButton = true;
                const isValid = await self.validateCreateFields('save');
                if(!isValid){
                    self.disableSaveButton = false;
                    return false;
                }

                axios.post(route('automation.save-automation'), self.form).then((response) => {
                    if (response.status) {
                        self.disableSaveButton = false;
                        self.getToast(1000).fire({
                            type: 'success',
                            title: response.data.message
                        });
                        window.location = route('automation.index');
                    } else {
                        self.disableSaveButton = false;
                        self.getToast().fire({
                            type: 'error',
                            title: response.data.message
                        });
                    }
                })
                .catch((error) => {
                    self.disableSaveButton = false;
                });
            },
            async validateCreateFields(type){
                const self = this;
                switch(type) {
                    case 'next':
                        if(!self.form.automation_type) {
                            self.showToast('error', 'Please select automation type')
                            return false
                        }
                        if(!self.form.automation_object) {
                            self.showToast('error', 'Please select automation object')
                            return false
                        }
                        if(!self.form.automation_trigger) {
                            self.showToast('error', 'Please select automation trigger')
                            return false
                        }
                        if(self.form.automation_trigger === 'updated' && self.form.automation_conditions.length === 0) {
                            self.showToast('error', 'Please add conditions');
                            return false;
                        }
                        if(['activity_added', 'activity_completed', 'activity_due'].includes(self.form.automation_trigger) && self.form.automation_field === 'empty') {
                            self.showToast('error', 'Please select field ');
                            return false;
                        }
                        return true
                        break;
                    case 'save':
                        if(!self.form.name || self.form.name.trim() === "") {
                            self.showToast('error', 'Please enter automation name')
                            return false;
                        }
                        await self.checkAutomationNameAlreadyExists();
                        if(self.automationNameAlreadyExists) {
                            self.showToast('error', 'Automation name already exists')
                            return false;
                        }

                        return this.validateAutomationActions();
                        break;

                }
            },
            showToast(type, title){
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000
                });
                Toast.fire({
                    type: type,
                    title: title
                });
            },
            debounceTimeBased: _.debounce(function(e) {
                const self = this;
                if(e.target.value && e.target.value !== ""){
                    self.form.automation_type = 'time_based'
                    // self.project_fields = [...self.project_fields, ...self.sales_behaviours];
                }else{
                    self.form.automation_type = null
                }
                self.form.automation_object = null
                self.form.automation_trigger = null
                self.form.automation_field = 'empty'
                self.form.input_value = null
                self.form.action = null
                self.form.action_object = null
                self.form.automation_conditions = [];
                self.$refs.AutomationConditions.finalConditions = [];
            }, 600),
            selectTemplate(template){
                this.form.automationActions[this.currentAutomationActionIndex].selectedTemplateName = template.template_name
                this.form.automationActions[this.currentAutomationActionIndex].automationTemplateId = template.id
            },
            openEmailTemplateModal(actionIndex) {
                this.$refs.EmailTemplateModal.open(true);
                this.currentAutomationActionIndex = actionIndex;
            },
            filteredFieldsSelected() {
                const self = this;
                self.form.automation_exclude_field = 'exclude_field';
            },
            formatTriggerLabel(field) {
                let label = '';
                switch (field) {
                    case "gross_margin_percentage":
                        label = 'Gross Margin';
                        break;
                    case "contact_types_id":
                        label = 'Contact Type';
                        break;
                    case "company_types_id":
                        label = 'Company Type';
                        break;
                    case "sales_status_id":
                    case "marketing_status_id":
                    case "lead_from_id":
                    case "client_profile_id":
                    case "contract_type_id":
                    case "account_manager_id":
                    case "office_id":
                    case "estimator_id":
                    case "take_off_person_id":
                    case "user_id":
                    case "products_and_services_id":
                        label = field.replace("_id", " ");
                        break;
                    default:
                        label = field;
                        break;
                }

                let recordDetailField = _.find(ProjectRecordDetailFields, { property_name: field });
                if(recordDetailField !== undefined) {
                    return this.getFieldLabel(this.recordDetailFieldLabels, recordDetailField.id);
                }

                let dataField = _.find(ProjectDataFields, { property_name: field });
                if(dataField !== undefined) {
                    return this.getFieldLabel(this.fieldLabels, dataField.id);
                }

                label = label.replaceAll("_", " ");
                return label;
            },
            getProjectSalesBehaviors() {
                let projectSaleBehaviorsArray = [];
                let projectSalesBehaviours = this.sales_behaviours;

                if(projectSalesBehaviours.length > 0) {
                    projectSalesBehaviours.forEach((projectSaleBehavior) => {
                        projectSaleBehaviorsArray.push(projectSaleBehavior.property_name);
                    });
                }

                return projectSaleBehaviorsArray;
            },
            getContactSalesBehaviors() {
                let contactSaleBehaviorsArray = [];
                let contactSalesBehaviours = this.allContactFields.filter(contact => contact.type === 'date');
                if(contactSalesBehaviours.length > 0) {
                    contactSalesBehaviours.forEach((contactSaleBehavior) => {
                        contactSaleBehaviorsArray.push(contactSaleBehavior.property_name);
                    });
                }

                return contactSaleBehaviorsArray;
            },
            selectedActionOption(option) {
                this.form.automationActions[this.currentAutomationActionIndex].inputActionValue = option.id
                if(this.form.automationActions[this.currentAutomationActionIndex].actionFieldObject.is_custom_field) {
                    this.form.automationActions[this.currentAutomationActionIndex].selectedActionValue = option.name
                }
                else {
                    this.form.automationActions[this.currentAutomationActionIndex].selectedActionValue = option.code
                }
            },
            selectedActionUserOption(user) {
                this.form.automationActions[this.currentAutomationActionIndex].inputActionValue = user.id;
                this.form.automationActions[this.currentAutomationActionIndex].selectedActionValue = user.name;
            },
            selectedProjectEmailOption(value) {
                if(value === 'company_contact'){
                    this.selectedProjectEmailType = 'Company Contact - First Contact'
                }else{
                    this.selectedProjectEmailType = value;
                }
            },
            addCustomFieldsAndSalesActivities(projectFields){
                let salesActivitiesData = [];
                if(this.all_codes?.sales_activities?.length > 0){
                    this.all_codes.sales_activities.forEach((item, index) => {
                        let numberToAppend = index+508;
                        salesActivitiesData.push({
                            id: numberToAppend,
                            button: 'add'+item.name.replace(/\b\w/g, char => char.toUpperCase()).replace(/\s+/g, ''),
                            text: item.name,
                            buttonCode: 'replace'+item.name.replace(/\b\w/g, char => char.toUpperCase()).replace(/\s+/g, '')
                        })
                    })
                }
                projectFields[1].optionValues = salesActivitiesData;

                let formattedCustomfields = [];
                let counter = 29;
                formattedCustomfields = this.customFields.map(field => {
                    if(field.enabled == 1){
                        const fieldName = field.label_value.replace(/\s+/g, '')
                        counter++;
                        return {
                            id: counter,
                            button: 'add'+fieldName,
                            text: field.label_value,
                            buttonCode: 'replace'+fieldName
                        }
                    }
                });
                if(formattedCustomfields.length > 0){
                    formattedCustomfields = formattedCustomfields.filter(item => item !== undefined);
                }

                projectFields[2].optionValues = formattedCustomfields;
                return this.applyFieldLabels(projectFields);
            },
            fetchCustomFields() {
                axios.get(route('api.project-custom-field.index')).then(({data}) => {
                    this.customFields = data.data;
                    this.addCustomFieldsAndSalesActivities(TemplateFields.project);
                });
            },
            applyFieldLabels(projectFields){
                if(projectFields.length > 0){
                    projectFields[0].optionValues.forEach(field => {
                        switch(field['text']) {
                            case 'Sales Status':
                                field['text'] = (this.projectDataFieldVisibility['sales-status'])? this.getFieldLabel(this.fieldLabels, 'sales-status'):null;
                                break;
                            case 'Marketing Status':
                                field['text'] = (this.projectDataFieldVisibility['marketing-status'])? this.getFieldLabel(this.fieldLabels, 'marketing-status'):null;
                                break;
                            case 'Pre Bid':
                                field['text'] = (this.projectDataFieldVisibility['pre-bid'])? this.getFieldLabel(this.fieldLabels, 'pre-bid'):null;
                                break;
                            case 'Bid Date':
                                field['text'] = (this.projectDataFieldVisibility['bid-date'])? this.getFieldLabel(this.fieldLabels, 'bid-date'):null;
                                break;
                            case 'Lead Source':
                                field['text'] = (this.projectDataFieldVisibility['lead-source'])? this.getFieldLabel(this.fieldLabels, 'lead-source'):null;
                                break;
                            case 'Estimator':
                                field['text'] = (this.projectDataFieldVisibility['estimator'])? this.getFieldLabel(this.fieldLabels, 'estimator'):null;
                                break;
                            case 'Account Manager':
                                field['text'] = (this.projectDataFieldVisibility['account-manager'])? this.getFieldLabel(this.fieldLabels, 'account-manager'):null;
                                break;
                            case 'Take Off Person':
                                field['text'] = (this.projectDataFieldVisibility['take-off-person'])? this.getFieldLabel(this.fieldLabels, 'take-off-person'):null;
                                break;
                            case 'Product And Services':
                                field['text'] = (this.projectDataFieldVisibility['products-and-services'])? this.getFieldLabel(this.fieldLabels, 'products-and-services'):null;
                                break;
                            case 'Client Profile':
                                field['text'] = (this.projectDataFieldVisibility['client-profile'])? this.getFieldLabel(this.fieldLabels, 'client-profile'):null;
                                break;
                            case 'Contract Type':
                                field['text'] = (this.projectDataFieldVisibility['contract-type'])? this.getFieldLabel(this.fieldLabels, 'contract-type'):null;
                                break;
                            case 'Office':
                                field['text'] = (this.projectDataFieldVisibility['office'])? this.getFieldLabel(this.fieldLabels, 'office'):null;
                                break;

                        }
                    })
                }
                projectFields[0].optionValues = projectFields[0].optionValues.filter(item => item.text !== null);
                return projectFields;
            },
            checkAutomationAlreadyCompanyShared() {
                const urlString = window.location.href;
                const url = new URL(urlString);
                const isShared = url.searchParams.get("is_shared");
                if(isShared && isShared === 'true' && this.eligibleUserRolesForCompanyAutomation.includes(this.userRole)) {
                    this.form.is_shared = true;
                }
            },
            openSequenceModal(actionIndex) {
                this.$refs.EmailSequenceModal.open(true);
                this.currentAutomationActionIndex = actionIndex;
            },
            selectSequence(sequence) {
                this.form.automationActions[this.currentAutomationActionIndex].selectedSequenceName = sequence.name;
                this.form.automationActions[this.currentAutomationActionIndex].emailSequenceId = sequence.id;
            },
            addRecipient(newEmail) {
                let mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
                if (newEmail.match(mailFormat)) {
                    const tag = {email: newEmail};
                    this.form.automationActions[this.currentAutomationActionIndex].nonUserRecipientEmailAddresses.push(tag);
                }
                else {
                    this.getToast().fire({
                        type: 'error',
                        title: 'You have entered an invalid email address!'
                    });
                }
            },
            closeFilterActionNonUserModal() {
                $('#filterActionNonUserModal').modal('hide');
                this.form.automationActions[this.currentAutomationActionIndex].nonUserSenderName = null;
                this.form.automationActions[this.currentAutomationActionIndex].nonUserSenderEmailAddress = null;
                this.form.automationActions[this.currentAutomationActionIndex].nonUserRecipientEmailAddresses = [];
            },
            addNewAction() {
                if(this.validateAutomationActions()) {
                    this.form.automationActions.push(_.cloneDeep(multiActionObject));
                }
            },
            openCustomModal(modalId, actionIndex) {
                $('#' + modalId).modal('show');
                this.currentAutomationActionIndex = actionIndex;
            },
            resetAutomationActions() {
                this.form.automationActions = [];
                this.form.automationActions.push(_.cloneDeep(multiActionObject));
            },
            removeAutomationAction(index) {
                if(this.form.automationActions.length > 1) {
                    this.form.automationActions.splice(index, 1);
                }
                this.currentAutomationActionIndex = 0;
            },
            automationActionDate(index) {
                let self = this;
                if(self.form.automationActions[index].actionIsFixedDate === 'fixed' && self.form.automationActions[index].inputActionValue) {
                    self.form.automationActions[index].inputActionValue = (new Date(self.form.automationActions[index].inputActionValue)).toUTCString();
                    if(self.form.automationActions[index].actionSalesBehaviorId) {
                        return moment(self.form.automationActions[index].inputActionValue).isValid() ? (this.team.has_calendar_access ? (moment(self.form.automationActions[index].inputActionValue).utc().format('YYYY-MM-DD') + ' ' + (self.form.automationActions[index].salesBehaviorHour + ':' + self.form.automationActions[index].salesBehaviorMinute + ' ' + self.form.automationActions[index].salesBehaviorAMPM)) : moment(self.form.automationActions[index].inputActionValue).utc().format('YYYY-MM-DD')) : '';
                    }
                    else {
                        return moment(self.form.automationActions[index].inputActionValue).isValid() ? moment(self.form.automationActions[index].inputActionValue).utc().format('YYYY-MM-DD') : '';
                    }
                }
                else if(self.form.automationActions[index].actionIsFixedDate === 'not_fixed' && self.form.automationActions[index].inputActionValue) {
                    if(self.form.automationActions[index].actionSalesBehaviorId) {
                        return this.team.has_calendar_access ? self.form.automationActions[index].inputActionValue + ' days (Time: ' + (self.form.automationActions[index].salesBehaviorHour + ':' + self.form.automationActions[index].salesBehaviorMinute + ' ' + self.form.automationActions[index].salesBehaviorAMPM) + ') after automation triggered' : self.form.automationActions[index].inputActionValue + ' days after automation triggered';
                    }
                    else {
                        return self.form.automationActions[index].inputActionValue + ' days after automation triggered';
                    }
                }
                else if(self.form.automationActions[index].actionIsFixedDate === 'clear_date_time') {
                    return 'date and time will be cleared out';
                }
                else {
                    return null;
                }
            },
            validateAutomationActions() {
                let self = this;

                for(let i = 0; i < this.form.automationActions.length; i++) {
                    let key = i + 1;
                    if(!this.form.automationActions[i].action) {
                        self.showToast('error', 'Please select action type for action # ' + key);
                        return false;
                    }
                    if(!this.form.automationActions[i].actionObject) {
                        self.showToast('error', 'Please select action object for action # ' + key);
                        return false;
                    }
                    if(this.form.automationActions[i].action === 'action_update' && this.form.automationActions[i].actionObject !== 'action_sequence' && (!this.form.automationActions[i].actionField || this.form.automationActions[i].actionField === 'empty')) {
                        self.showToast('error', 'Please select action filter field for action # ' + key);
                        return false;
                    }
                    if(this.form.automationActions[i].action === 'action_update' && this.form.automationActions[i].actionObject !== 'action_sequence' && !this.form.automationActions[i].inputActionValue) {
                        if((this.form.automationActions[i].actionSalesBehaviorId && this.form.automationActions[i].actionIsFixedDate !== 'clear_date_time') || !this.form.automationActions[i].actionSalesBehaviorId) {
                            self.showToast('error', 'Please select action filter value for action # ' + key);
                            return false;
                        }
                    }
                    if(this.form.automationActions[i].action === 'action_update' && this.form.automationActions[i].actionObject === 'action_sequence' && !this.form.automationActions[i].emailSequenceId) {
                        self.showToast('error', 'Please select action sequence for action # ' + key);
                        return false;
                    }
                    if(this.form.automationActions[i].action === 'action_email' && (this.form.automationActions[i].actionObject === 'action_project' || this.form.automationActions[i].actionObject === 'action_user') && this.form.automationActions[i].emailActionDropDownValues.length === 0) {
                        self.showToast('error', 'Please select action filter for action # ' + key);
                        return false;
                    }
                    if(this.form.automationActions[i].action === 'action_email' && this.form.automationActions[i].actionObject === 'action_non_user' && !this.form.automationActions[i].nonUserSenderEmailAddress) {
                        self.showToast('error', 'Please enter action sender email address for action # ' + key);
                        return false;
                    }
                    if(this.form.automationActions[i].action === 'action_email' && this.form.automationActions[i].actionObject === 'action_non_user' && this.form.automationActions[i].nonUserRecipientEmailAddresses.length === 0) {
                        self.showToast('error', 'Please enter action recipient emails for action # ' + key);
                        return false;
                    }
                    if(this.form.automationActions[i].action === 'action_email' && !this.form.automationActions[i].automationTemplateId) {
                        self.showToast('error', 'Please select action email template for action # ' + key);
                        return false;
                    }
                }

                return true;
            },
            createHoursMinutesData() {
                for(let i = 0; i < 60; i++) {
                    if(i > 0 && i < 13) {
                        this.hoursArray.push(i < 10 ? '0' + i : i.toString());
                    }
                    this.minutesArray.push(i < 10 ? '0' + i : i.toString());
                }
            },
            formatActionFieldName(name) {
                const dropdownColumns = ['sales_status_id', 'marketing_status_id', 'lead_from_id', 'client_profile_id', 'contract_type_id',
                    'office_id', 'products_and_services_id', 'estimator_id', 'account_manager_id', 'take_off_person_id', 'company_types_id',
                    'contact_types_id', 'team_contact_status', 'user_id'];

                let recordDetailField = _.find(ProjectRecordDetailFields, { property_name: name });
                if(recordDetailField !== undefined) {
                    return this.getFieldLabel(this.recordDetailFieldLabels, recordDetailField.id);
                }

                let dataField = _.find(ProjectDataFields, { property_name: name });
                if(dataField !== undefined) {
                    return this.getFieldLabel(this.fieldLabels, dataField.id);
                }

                if(dropdownColumns.includes(name)) {
                    name = name.replace(/_id$/, '');
                }
                return name.replace(/_/g, ' ');
            },
            async checkAutomationNameAlreadyExists() {
                let self = this;
                let payload = {
                    name: self.form.name,
                    automationId: null,
                    isShared: self.form.is_shared
                };

                await axios.post(route('automation.name-already-exists'), payload).then((response) => {
                    self.automationNameAlreadyExists = response.data.status;
                }).catch((error) => {
                    self.automationNameAlreadyExists = false;
                });
            },
            getFilterActionModalClass(actionIndex) {
                let modalClass = '';

                if(this.form.automationActions[actionIndex].actionFieldObject.type === 'date') {
                    if(this.form.automationActions[actionIndex].actionFieldObject.hasOwnProperty('is_sales_behavior') && this.form.automationActions[actionIndex].actionFieldObject.is_sales_behavior) {
                        if(this.form.automationActions[actionIndex].actionIsFixedDate !== 'clear_date_time') {
                            modalClass = this.form.automationActions[actionIndex].inputActionValue ? (this.showTimeSelectionBar ? 'modal-xl' : 'modal-lg') : 'modal-lg';
                        }
                    }
                    else {
                        modalClass = 'modal-lg';
                    }
                }

                return modalClass;
            },
        },
        computed: {
            allProjectFields() {
                let self = this;
                if(['activity_added', 'activity_completed', 'activity_due'].includes(this.form.automation_trigger)) {
                    return this.sales_behaviours
                }
                else {
                    let filteredProjectRecordDetailFields = [];
                    let modifiedProjectRecordDetailFields = [];
                    let modifiedProjectDataFields = [];

                    if(!this.team.has_probability_access) {
                        filteredProjectRecordDetailFields = ProjectField.recordDetailFields.filter(item => item['property_name'] !== 'estimated_contract_date');
                    }
                    else {
                        filteredProjectRecordDetailFields = ProjectField.recordDetailFields;
                    }

                    modifiedProjectRecordDetailFields = _.map(filteredProjectRecordDetailFields, (field) => {
                        let recordDetailField = _.find(ProjectRecordDetailFields, { property_name: field.property_name });
                        if(recordDetailField !== undefined) {
                            field.name = self.getFieldLabel(self.recordDetailFieldLabels, recordDetailField.id);
                        }
                        return field;
                    });

                    modifiedProjectDataFields = _.map(ProjectField.projectDataFields, (field) => {
                        let dataField = _.find(ProjectDataFields, { property_name: field.property_name });
                        if(dataField !== undefined) {
                            field.name = self.getFieldLabel(self.fieldLabels, dataField.id);
                        }
                        return field;
                    });

                    return [
                        ...(Array.isArray(ProjectField.infoFields) ? ProjectField.infoFields : []),
                        ...(Array.isArray(modifiedProjectDataFields) ? modifiedProjectDataFields : []),
                        ...(Array.isArray(this.project_custom_fields) ? this.project_custom_fields : []),
                        ...(Array.isArray(modifiedProjectRecordDetailFields) ? modifiedProjectRecordDetailFields : []),
                        ...(Array.isArray(this.recordDetailCustomFields) ? this.recordDetailCustomFields : []),
                        ...(Array.isArray(this.sales_behaviours) ? this.sales_behaviours : [])
                    ];
                }
            },
            allContactFields() {
                if(this.form.automation_trigger !== 'created') {
                    if(['activity_added', 'activity_completed', 'activity_due'].includes(this.form.automation_trigger)) {
                        return this.contact_activities
                    }
                    else {
                        return [
                            ...(Array.isArray(ContactField) ? ContactField : []),
                            ...(Array.isArray(this.contact_activities) ? this.contact_activities : []),
                            ...(Array.isArray(this.contact_custom_fields) ? this.contact_custom_fields : []),
                        ];
                    }
                }
                else {
                    return [
                        ...(Array.isArray(ContactField) ? ContactField : []),
                        ...(Array.isArray(this.contact_custom_fields) ? this.contact_custom_fields : []),
                    ];
                }
            },
            allCompanyFields() {
                return [
                    ...(Array.isArray(CompanyField) ? CompanyField : []),
                    ...(Array.isArray(this.company_custom_fields) ? this.company_custom_fields : []),
                ];
            },
            allContactActionFields(){
                return [...ContactField, ...this.contact_activities, ...this.contact_custom_fields];
            },
            allProjectActionFields() {
                let self = this;
                let filteredProjectRecordDetailFields = [];
                let modifiedProjectRecordDetailFields = [];
                let modifiedProjectDataFields = [];

                if(!this.team.has_probability_access) {
                    filteredProjectRecordDetailFields = ProjectField.recordDetailFields.filter(item => item['property_name'] !== 'estimated_contract_date');
                }
                else {
                    filteredProjectRecordDetailFields = ProjectField.recordDetailFields;
                }

                modifiedProjectRecordDetailFields = _.map(filteredProjectRecordDetailFields, (field) => {
                    let recordDetailField = _.find(ProjectRecordDetailFields, { property_name: field.property_name });
                    if(recordDetailField !== undefined) {
                        field.name = self.getFieldLabel(self.recordDetailFieldLabels, recordDetailField.id);
                    }
                    return field;
                });

                modifiedProjectDataFields = _.map(ProjectField.projectDataFields, (field) => {
                    let dataField = _.find(ProjectDataFields, { property_name: field.property_name });
                    if(dataField !== undefined) {
                        field.name = self.getFieldLabel(self.fieldLabels, dataField.id);
                    }
                    return field;
                });

                return [
                    ...(Array.isArray(ProjectField.infoFields) ? ProjectField.infoFields : []),
                    ...(Array.isArray(modifiedProjectDataFields) ? modifiedProjectDataFields : []),
                    ...(Array.isArray(this.project_custom_fields) ? this.project_custom_fields : []),
                    ...(Array.isArray(modifiedProjectRecordDetailFields) ? modifiedProjectRecordDetailFields : []),
                    ...(Array.isArray(this.recordDetailCustomFields) ? this.recordDetailCustomFields : []),
                    ...(Array.isArray(this.sales_behaviours) ? this.sales_behaviours : [])
                ];
            },
            templateFields(){
                if(this.form.automation_trigger === 'deleted'){
                    return [];
                }else{
                    switch(this.form.automation_object) {
                        case 'project':
                            return this.addCustomFieldsAndSalesActivities(TemplateFields.project)
                        case 'company':
                            return TemplateFields.company
                        case 'contact':
                            return TemplateFields.contact
                        default:
                            return TemplateFields.default
                    }
                }


            },
            filteredProjectFields() {
                return this.allProjectActionFields.filter(project => project.type === 'dropdown');
            },
            filteredContactFields() {
                return this.allContactActionFields.filter(contact => contact.type === 'dropdown');
            },
            isButtonDisabled() {
                return this.form.automation_type === 'time_based' && this.form.time_based.time_operator === 'before'
            },
            selectedUserForEmail() {
                let self = this;
                if(typeof self.form.action_field_object !== 'object' && self.form.action_field_object) {
                    return self.dropdown_user_values.find(x => x.id === self.form.action_field_object)?.name
                }else{
                    return null;
                }
            },
            actionDate() {
                let self = this;
                if(self.form.automationActions[self.currentAutomationActionIndex].actionIsFixedDate === 'fixed' && self.form.automationActions[self.currentAutomationActionIndex].inputActionValue) {
                    self.form.automationActions[self.currentAutomationActionIndex].inputActionValue = (new Date(self.form.automationActions[self.currentAutomationActionIndex].inputActionValue)).toUTCString();
                    if(self.form.automationActions[self.currentAutomationActionIndex].actionSalesBehaviorId) {
                        return moment(self.form.automationActions[self.currentAutomationActionIndex].inputActionValue).isValid() ? (this.team.has_calendar_access ? (moment(self.form.automationActions[self.currentAutomationActionIndex].inputActionValue).utc().format('YYYY-MM-DD') + ' ' + (self.form.automationActions[self.currentAutomationActionIndex].salesBehaviorHour + ':' + self.form.automationActions[self.currentAutomationActionIndex].salesBehaviorMinute + ' ' + self.form.automationActions[self.currentAutomationActionIndex].salesBehaviorAMPM)) : moment(self.form.automationActions[self.currentAutomationActionIndex].inputActionValue).utc().format('YYYY-MM-DD')) : '';
                    }
                    else {
                        return moment(self.form.automationActions[self.currentAutomationActionIndex].inputActionValue).isValid() ? moment(self.form.automationActions[self.currentAutomationActionIndex].inputActionValue).utc().format('YYYY-MM-DD') : '';
                    }
                }
                else if(self.form.automationActions[self.currentAutomationActionIndex].actionIsFixedDate === 'not_fixed' && self.form.automationActions[self.currentAutomationActionIndex].inputActionValue) {
                    if(self.form.automationActions[self.currentAutomationActionIndex].actionSalesBehaviorId) {
                        return this.team.has_calendar_access ? self.form.automationActions[self.currentAutomationActionIndex].inputActionValue + ' days (Time: ' + (self.form.automationActions[self.currentAutomationActionIndex].salesBehaviorHour + ':' + self.form.automationActions[self.currentAutomationActionIndex].salesBehaviorMinute + ' ' + self.form.automationActions[self.currentAutomationActionIndex].salesBehaviorAMPM) + ') after automation triggered' : self.form.automationActions[self.currentAutomationActionIndex].inputActionValue + ' days after automation triggered';
                    }
                    else {
                        return self.form.automationActions[self.currentAutomationActionIndex].inputActionValue + ' days after automation triggered';
                    }
                }
                else if(self.form.automationActions[self.currentAutomationActionIndex].actionIsFixedDate === 'clear_date_time') {
                    return 'date and time will be cleared out';
                }
                else {
                    return null;
                }
            }
        }
    }
</script>
<style scoped>
.selected_button{
    border: 2px solid black;
    border-radius: 5px;
}
.automation-trigger {
    border-top: 1px solid #dae1e7;
    border-bottom: 1px solid #dae1e7;
}
.trigger{
    padding: 8px 30px;
    background: #ebebeb;
}
.btn-purple{
    background: #6e7ff2;
}
.btn-blue{
    background: #3c71b8;
}
.btn-light-green{
    background: #9af6c0;
}
.btn-light-red{
    background: #f87676;
}
.btn-light-red{
    background: #f87676;
}
.btn-light-yellow{
    background: #eeea7d;
}
.br-5{
    border-radius: 5px;
}
.custom-height{
    min-height: 60vh;
}
.required-field {
    color: red;
}
.field-height {
    min-height: 37px;
    max-height: 37px;
    border: 1px solid #b0b9bf
}
.card-header {
    background-color: rgba(0,0,0,.03);
}
.modal-header {
    background-color: inherit !important;
    border-bottom: none !important;
}
.date-picker-ui {
    height: 27px;
    width: 203px;
    border-radius: 4px;
}
.time-based-properties-section {
    width: 40%;
    border: 1px solid #c7bfbf;
    border-radius: 6px;
    padding: 20px 8px;
}
.sales-behavior-time-selection {
    padding: 0px 10px;
    border-radius: 5px;
    border: 1px solid #dde1e3;
}
.dropdown-menu.dropdown-menu-wide {
    min-width: 100%;
    text-align: center;
    max-height: 200px;
    overflow-y: scroll;
}
.custom-w-30 {
    width: 30%;
}
.custom-w-10 {
    width: 10%;
}
.custom-btn-shadow {
    box-shadow: 0 1px 2px #767676 !important;
}
.sales-behavior-time-input[readonly] {
    background-color: #fff !important;
}
</style>

